import {
	PI_CATEGORIES_FETCH_REQUEST,
	PI_CATEGORIES_FETCH_FAILURE,
	PI_CATEGORIES_FETCH_SUCCESS,
	PI_CATEGORY_FETCH_REQUEST,
	PI_CATEGORY_FETCH_FAILURE,
	PI_CATEGORY_FETCH_SUCCESS,
	PI_CATEGORY_UPDATE_REQUEST,
	PI_CATEGORY_UPDATE_FAILURE,
	PI_CATEGORY_UPDATE_SUCCESS,
	PI_CATEGORY_CREATE_REQUEST,
	PI_CATEGORY_CREATE_FAILURE,
	PI_CATEGORY_CREATE_SUCCESS,
	PI_CATEGORY_SET,
	PI_CATEGORY_RESET_MESSAGE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case PI_CATEGORY_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case PI_CATEGORY_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_CATEGORIES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case PI_CATEGORIES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case PI_CATEGORIES_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_CATEGORY_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case PI_CATEGORY_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case PI_CATEGORY_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.id),
			};

		case PI_CATEGORY_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_CATEGORY_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PI_CATEGORY_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PI_CATEGORY_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PI_CATEGORY_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PI_CATEGORY_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/PICategories.js